import { h } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import { IdeaStatus } from './Types'
import ButtonControl from '../button-control'

interface Props {
  idx: number,
  item: IdeaStatus,
  colors: Array<string>,
  deleteCallback: (idx: number) => void,
  openEditIdeationModal: (item: IdeaStatus, idx: number) => void,
}

const IdeationListItem = (props: Props) => {
  const item = props.item
  const statusStyle = {
    background: item.backgroundColor,
    color: item.textColor
  }
  return ({
    status: (
      <div>
        <span style={statusStyle} className='ideation-list__table-body-item-status-name'>{ item.name }</span>
        {
          item.default ? (
            <span className='ideation-list__table-body-item-status-default'>
                Default
              <Tooltip
                trigger={<i className='fa fa-question-circle' />}
                tooltipMessage={'Default status will be automatically assigned when a new idea is created'}
              />
            </span>
          ) : null
        }
      </div>
    ),
    bgColor: (
      <div className='ideation-list__table-body-item-color-container'>
        <span style={{ backgroundColor: item.backgroundColor }} className='ideation-list__table-body-item-color ideation-color-preview' />
        <span>{item.backgroundColor}</span>
      </div>
    ),
    textColor: (
      <div className='ideation-list__table-body-item-color-container'>
        <span style={{ backgroundColor: item.textColor }} className='ideation-list__table-body-item-color ideation-color-preview' />
        <span>{item.textColor}</span>
      </div>
    ),
    actions: (
      <div>
        <ButtonControl
          newStyle
          variant='secondary'
          title='Edit'
          onClick={() => props.openEditIdeationModal(item, props.idx)}
        />
        {
          !item.default ? (
            <ButtonControl
              newStyle
              variant='warning'
              size='small'
              title='Delete'
              onClick={() => props.deleteCallback(props.idx)}
            />
          ) : null
        }
      </div>
    )
  })
}

export default IdeationListItem
